import axios from 'axios'
import store from '@/store';
import { Toast } from 'vant';

const service = axios.create({
    baseURL: process.env.VUE_APP_API_ENDPOINT,
    timeout: 50000
})
service.defaults.retry = 3; //断线重连 次数
service.defaults.retryDelay = 1000; //断线重连 间隔时间


service.interceptors.request.use(function (config) {
    store.state.api_loading = true;

    // const language = sessionStorage.getItem('CASA_language');
    // if (language) {
    //     config.headers['language'] = language;
    // }
    // const userid = sessionStorage.getItem('CASA_userid');
    // if (userid) {
    //     config.headers['userid'] = userid;
    // }
    // const token = sessionStorage.getItem('CASA_token');
    // if (token) {
    //     config.headers['token'] = token;
    // }
    config.headers['device-os'] = "webtoken";

    return config;
}, function (error) {
    if(error){
        store.state.api_loading = false;
        Toast(error.response?.status);
    }
    return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(function (response) {
    store.state.api_loading = false;

    return response;
}, function (error) {
    if(error){
        store.state.api_loading = false;
        Toast("Network Error");
    }
    return Promise.reject(error);
});

export default service